import React, { Component } from "react";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { getDashboard } from "../../../crud/dashboard.crud";
import BetterCircularProgress from "../../../components/BetterCircularProgress";
import Swal from "sweetalert2";
import { formatBRL } from "../../../utils/Utils";
import BetterBox from "../../../components/BetterBox";
import { Col } from "react-bootstrap";
import { Chart } from "primereact/chart";
import { renderGraficoData, renderGraficoOptions } from "./DashboardUtils";

export default class DashboardPage extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            data: null,
        };
    }

    componentDidMount = () => {
        this.setState({ loading: true });

        getDashboard()
            .then((res) => {
                if (res.data.errors) {
                    return Swal.fire("Ops!", res.data.errors[0], "error");
                }

                this.setState({ data: res.data, loading: false });
            })
            .catch(() => Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"));
    };

    render() {
        return (
            <BetterCircularProgress loading={this.state.loading}>
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: "4px solid #113DFF" }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc">{`Empresas ativas`}</span>

                                        <span className="kt-widget26__number">{this.state.data?.empresas_ativas_count}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: "4px solid #113DFF" }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc">{`Faturamento total`}</span>

                                        <span className="kt-widget26__number">{this.state.data?.faturamento_total ? formatBRL(this.state.data.faturamento_total) : formatBRL(0)}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-4">
                        <Portlet className="kt-portlet--border-bottom-brand" style={{ borderBottom: "4px solid #113DFF" }} fluidHeight={true}>
                            <PortletBody>
                                <div className="kt-widget26">
                                    <div className="kt-widget26__content">
                                        <span className="kt-widget26__desc">{`Usuários`}</span>

                                        <span className="kt-widget26__number">{this.state.data?.usuarios_count}</span>
                                    </div>
                                </div>
                            </PortletBody>
                        </Portlet>
                    </div>
                </div>

                <BetterBox title="Faturamento" subtitle="Faturamento nos últimos 12 meses.">
                    <div className="row">
                        <div className="col-sm-12">
                            {this.state.data?.faturamento ? (
                                <Chart type="line" data={renderGraficoData(this.state.data.faturamento)} options={renderGraficoOptions()} />
                            ) : (
                                <Col sm={12} style={{ marginTop: "15px" }}>
                                    <center>
                                        <h5>Sem faturamento recente.</h5>
                                    </center>
                                </Col>
                            )}
                        </div>
                    </div>
                </BetterBox>
            </BetterCircularProgress>
        );
    }
}
